/**
 * packs/unpack for compareProductsIds to store in cookies,
 * unpacked format is array of numeric productids
 * packed format is comma separated list
 */
export const unpackCompareProductIds = (str) => {
  if (str) {
    return JSON.parse(str);
  }
  return [];
};
export const packCompareProductIds = (list) => `[${(list || []).join(',')}]`;
